var map = {
	"./SMS.svg": 106,
	"./analytics.svg": 107,
	"./beautifulwebsite.svg": 108,
	"./blogwriting.svg": 109,
	"./briefcase.svg": 110,
	"./calendar.svg": 111,
	"./creditcards.svg": 112,
	"./digitalassessments.svg": 113,
	"./document.svg": 114,
	"./phonetracking.svg": 115,
	"./ratings reviews desktop clean.svg": 116,
	"./ratings reviews desktop.svg": 117,
	"./userprofiles.svg": 118,
	"./userprofiles2.svg": 119,
	"./userprofiles3.1.svg": 120,
	"./userprofiles3.svg": 121
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 105;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/icons ^\.\/.*$
// module id = 105
// module chunks = 0